import { cn } from "@/utils/cn";

interface PrimaryButtonProps {
    title: string;
    onClick: () => void;
    className?: string;
    isLoading?: boolean;
    textClassName?: string;
    disabled?: boolean;
    icon?: React.ReactNode;
}

export const PrimaryButton = ({ title, onClick, className, isLoading = false, textClassName, disabled = false, icon }: PrimaryButtonProps) => {
    return (
        <button
            onClick={onClick}
            className={cn(
                `border flex items-center justify-center gap-x-2 flex-row transition-all duration-300 border-primary-button h-[50px] text-white px-4 py-2 rounded-lg`,
                disabled
                    ? 'bg-primary-button  border-gray-400 cursor-not-allowed opacity-40 '
                    : 'bg-primary-button cursor-pointer hover:scale-105 hover:bg-primary-button-hover',
                className
            )}
            disabled={disabled}
        >
            <p className={cn(`font-clash-display text-white text-md font-semibold`, textClassName)}>{title}</p>
            {isLoading && <img src="/assets/icons/spinner.svg" alt="loading" className="w-4 h-4 animate-spin" loading="lazy" />}
            {!isLoading && icon}
        </button>
    );
};